const papersDataEdexcelIgcse = {
  mathematics: [
    {
      year: '2025',
      papers: [
        {
          label: '1H',
          link: 'https://drive.proton.me/urls/GNTX6QJXV8#I1Kj2NTKC8q5',
          marking: 'https://drive.proton.me/urls/E83W3WQ484#tebQ2GhaJiZS',
        },
        {
          label: '1HR',
          link: 'https://drive.proton.me/urls/9XEA4AH2XM#tJ5Re6zejEKI',
          marking: 'https://drive.proton.me/urls/8R17E0VVQR#yqayAwDUwKck',
        },
        {
          label: '2H',
          link: 'https://drive.proton.me/urls/12VR4ZHFGG#4Tpbwupr0GSW',
          marking: 'https://drive.proton.me/urls/CC84C9395R#nmaFdYtWXk1a',
        },
        {
          label: '2HR',
          link: 'https://drive.proton.me/urls/A7MJKRS348#bFTyM0xHXLRY',
          marking: 'https://drive.proton.me/urls/ZT37YN3NGG#Hu8rsZMpIgAg',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1h-que-20240517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1h-rms-20240822.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1hr-que-20240517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1hr-rms-20240822.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2h-que-20240604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2h-rms-20240822.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2hr-que-20240604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2hr-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1h-que-20230520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1h-rms-20230824.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1hr-que-20230520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-1hr-rms-20230824.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2h-que-20230608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2h-rms-20230824.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2hr-que-20230608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Mathematics-A/2016/Exam-materials/4ma1-2hr-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20220111.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_rms_20220303.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20220111.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_rms_20220303.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20220118.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_rms_20220303.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20220118.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_rms_20220303.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_msc_20210304.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_msc_20210304.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_msc_20210304.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_msc_20210304.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_rms_20200305.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_rms_20200305.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_rms_20200305.pdf',
        },
        {
          label: '2HR',
          link:
            'https://pmt.physicsandmathstutor.com/download/Maths/GCSE/Past-Papers/Edexcel-IGCSE-A/Paper-2H/QP/June%202020%20(R)%20QP.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20190110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_msc_2019307.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20190110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_msc_20190307.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20190116.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_msc_20190307.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20190116.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_msc_20190307.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2025',
      papers: [
        {
          label: '1P',
          link: 'https://drive.proton.me/urls/GZN5TQ7FV8#bAlJoem9oo1k',
          marking: 'https://drive.proton.me/urls/5AH41ZZBNG#Rs9ThQAiObpG',
        },
        {
          label: '1PR',
          link: 'https://drive.proton.me/urls/0DG75T1XSG#njuiU9lHLgnC',
          marking: 'https://drive.proton.me/urls/2CR0V8H1XM#4mB5jtQJDUAO',
        },
        {
          label: '2P',
          link: 'https://drive.proton.me/urls/11MSFGKZ9G#jrwIFyFZSXA4',
          marking: 'https://drive.proton.me/urls/R9SH7T0BFM#OEy1gpFIxLCQ',
        },
        {
          label: '2PR',
          link: 'https://drive.proton.me/urls/WZMQA65WQ0#JjfyWjI46jJ5',
          marking: 'https://drive.proton.me/urls/C4AGGQ2YV8#7DH5OG5iuBkZ',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1p-que-20240523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1p-rms-20240822.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1pr-que-20240523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1pr-rms-20240822.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2p-que-20240615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2p-rms-20240822.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2pr-que-20240615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2pr-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1p-que-20230526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1p-rms-20230824.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1pr-que-20230526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1pr-rms-20230824.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2p-que-20230617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2p-rms-20230824.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2pr-rms-20230824.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2pr-que-20230617.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1p-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1p-rms-20220825.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1pr-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1pr-rms-20220825.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2p-que-20220624.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2p-rms-20220825.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2pr-que-20220624.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2pr-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_msc_20210304.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_msc_20210304.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_msc_20210304.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_msc_20210304.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_rms_20200305.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_rms_20200305.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_rms_20200305.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_que_20190523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_rms_20190822.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_que_20190523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_rms_20190822.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_que_20190615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_rms_20190822.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_que_20190615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_rms_20190822.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2025',
      papers: [
        {
          label: '1C',
          link: 'https://drive.proton.me/urls/CV0ES1RNJC#67GZZsjWmcJG',
          marking: 'https://drive.proton.me/urls/W8PQNYQ4QW#ChOCBYN22TQX',
        },
        {
          label: '1CR',
          link: 'https://drive.proton.me/urls/V85TRFQVQW#brodfl2lS8Eo',
          marking: 'https://drive.proton.me/urls/49QY71V4AW#YtkYw1m9kko7',
        },
        {
          label: '2C',
          link: 'https://drive.proton.me/urls/5A572X4Y2C#40JirHb7fdgm',
          marking: 'https://drive.proton.me/urls/AH0K0CJ504#1Q2Ips29VUau',
        },
        {
          label: '2CR',
          link: 'https://drive.proton.me/urls/BAQ5TPANYW#XTslvIdRcFkh',
          marking: 'https://drive.proton.me/urls/PA32V6W66R#gEHWfKbO3a7i',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1c-que-20240518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1c-rms-20240822.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1cr-que-20240518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1cr-rms-20240822.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2c-que-20240612.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2c-rms-20240822.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2cr-que-20240612.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2cr-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1c-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1c-rms-20230824.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1cr-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1cr-rms-20230824.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2c-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2c-rms-20230824.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2cr-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2cr-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1c-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1c-rms-20220825.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1cr-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1cr-rms-20220825.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2c-que-20220621.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2c-rms-20220825.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2cr-que-20220621.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2cr-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_msc_20210304.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_msc_20210304.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_msc_20210304.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_msc_20210304.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_rms_20200305.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_que_20200305-.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_rms_20200305.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_rms_20200305.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_que_20190520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1-1C-msc-20190822-V2.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_rms_20190822.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_que_20190613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_rms_20190822.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_que_20190613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_rms_20190822.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2025',
      papers: [
        {
          label: '1B',
          link: 'https://drive.proton.me/urls/19GQRNS9N8#pKCsMIF9QAHg',
          marking: 'https://drive.proton.me/urls/3DN1YZGKK8#UJsW6kXrSdK2',
        },
        {
          label: '1BR',
          link: 'https://drive.proton.me/urls/QCG826SST4#YqTBYsyTBv7y',
          marking: 'https://drive.proton.me/urls/DR9Q9BWSE0#r3Gca4qa934W',
        },
        {
          label: '2B',
          link: 'https://drive.proton.me/urls/PP39NR60CW#AxATan4UCVbT',
          marking: 'https://drive.proton.me/urls/M5ZQPJTNJR#XhbSMi5QAr4w',
        },
        {
          label: '2BR',
          link: 'https://drive.proton.me/urls/BPETF8RK2W#vDxblrIXDbUM',
          marking: 'https://drive.proton.me/urls/58A94HWHVC#WsM3JXQYU0mo',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1b-que-20240511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1b-rms-20240822.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1br-que-20240511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1br-rms-20240822.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2b-que-20240608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2b-rms-20240822.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2br-que-20240702.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2br-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1b-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1b-rms-20230824.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1br-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1br-rms-20230824.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2b-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2b-rms-20230824.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2br-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2br-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1b-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1b-rms-20220825.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1br-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1br-rms-20220825.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2b-que-20220616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2b-rms-20220825.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2br-que-20220616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2br-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_msc_20210304.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_msc_20210304.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_msc_20210304.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_msc_20210304.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_rms_20200305.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_rms_20200305.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_rms_20200305.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_que_20190515.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_rms_20190822.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_que_20190515.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_rms_20190822.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_rms_20190822.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_rms_20190822.pdf',
        },
      ],
    },
  ],
  englishlanguage: [
    {
      year: '2025',
      papers: [
        {
          label: '1',
          link: 'https://drive.proton.me/urls/Q8RR2PVB4W#RdTDCHu2wF8y',
          marking: 'https://drive.proton.me/urls/XTN3KGPGW8#BmyEePQXtfcA',
        },
        {
          label: '1R',
          link: 'https://drive.proton.me/urls/E7Y4T3NAE8#wHxQZTd4tcq1',
          marking: 'https://drive.proton.me/urls/540Z7S85WW#sZzaJr8tRhUx',
        },
        {
          label: '2',
          link: 'https://drive.proton.me/urls/TJCP945738#1TcJWrAJRfiQ',
          marking: 'https://drive.proton.me/urls/XYXQYWT0PC#DpNusOxYEvnZ',
        },
        {
          label: '2R',
          link: 'https://drive.proton.me/urls/2PV7X6ESC8#BckSSlYzboUI',
          marking: 'https://drive.proton.me/urls/F8TJMXB11G#JWp8SDIWQ8eE',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-01-que-20240524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-01-rms-20240822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-01r-que-20240524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-01r-rms-20240822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-02-que-20240607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-02-rms-20240822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-02r-que-20240607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/English-Language-A/2016/Exam-materials/4ea1-02r-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-que-20230113.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-rms-20230302.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-que-20230113.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-rms-20230302.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-que-20230120.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-rms-20230302.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-que-20230120.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-rms-20230302.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-que-20220519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-que-20220519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-rms-20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_rms_20210604.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-que-20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_rms_20200305.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_rms_20200305.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_rms_20200305.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_que_20190605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_rms_20190822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_que_20190605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_rms_20190822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02__rms_20190822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_rms_20190822.pdf',
        },
      ],
    },
  ],
  businessstudies: [
    {
      year: '2025',
      papers: [
        {
          label: '1',
          link: 'https://drive.proton.me/urls/PR6WD8YQ6M#fzX5fzTuMWVz',
          marking: 'https://drive.proton.me/urls/H8D7R1036C#HzdI2W98eLBF',
        },
        {
          label: '1R',
          link: 'https://drive.proton.me/urls/HHS2QD124G#L1HB6eUeOERM',
          marking: 'https://drive.proton.me/urls/71CYFW5VXW#OflDaUvjykaK',
        },
        {
          label: '2',
          link: 'https://drive.proton.me/urls/K71989C9ZR#2eRUKlZPTc7o',
          marking: 'https://drive.proton.me/urls/ZGBC22Y6GG#XRlNNV2Z7DMy',
        },
        {
          label: '2R',
          link: 'https://drive.proton.me/urls/30J1D44HDG#0Xh90LR6Qy7d',
          marking: 'https://drive.proton.me/urls/483D73EP2G#hU6lhXPa847X',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01-que-20240514.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01-rms-20240822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01r-que-20240514.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01r-rms-20240822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02-que-20240604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02-rms-20240822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02r-que-20240604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02r-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01-que-20230518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01-rms-20230824.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01r-que-20230518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01r-rms-20230824.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02-que-20230613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02-rms-20230824.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02r-que-20230613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02r-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01-que-20220520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01r-que-20220520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-02-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_rms_20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-02r-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/Exam-materials/4BS1_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_rms_20210604.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/Exam-materials/4BS1_02_que_20210511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_que_20201110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_msc_20210211.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_que_20201110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_msc_20210211.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_que_20201117.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_msc_20210211.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02R_que_20201117.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02R_msc_20210211.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_rms_20190822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_rms_20190822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_rms_20190822.pdf',
        },
        {
          label: '2R',
          link:
            'https://cdn.savemyexams.com/uploads/2022/02/4bs1_02r-june-2019-paper-2r-qp-edexcel-igcse-business.pdf',
          marking:
            'https://cdn.savemyexams.com/uploads/2022/02/4bs1_02r-june-2019-paper-2r-ms-edexcel-igcse-business.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2025',
      papers: [
        {
          label: '1',
          link: 'https://drive.proton.me/urls/2R7WS7ZPMC#zPTlc5lLak1a',
          marking: 'https://drive.proton.me/urls/C2A47ST100#IDNEedLPNeZI',
        },
        {
          label: '1R',
          link: 'https://drive.proton.me/urls/4P82S6KMGG#cQYlkK2RSMOd',
          marking: 'https://drive.proton.me/urls/3E741H9N04#inAtgqE2penF',
        },
        {
          label: '2',
          link: 'https://drive.proton.me/urls/RHRYX3K1W8#nn3lmF8Hqj4k',
          marking: 'https://drive.proton.me/urls/PXMAQAV6MM#7cZqdwUd8wA5',
        },
        {
          label: '2R',
          link: 'https://drive.proton.me/urls/T09RD2JA5M#313J1SymI8q8',
          marking: 'https://drive.proton.me/urls/CYTC6EWTVC#rpAaLiOm4Lcy',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01-que-20240522.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01-rms-20240822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01r-que-20240522.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01r-rms-20240822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02-que-20240606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02-rms-20240822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02r-que-20240606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02r-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01-rms-20230824.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01r-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01r-rms-20230824.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02-que-20230615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02-rms-20230824.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02r-que-20230615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02r-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01-que-20220525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01r-que-20220525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02-rms-20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02r-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/Exam-materials/4EC1_01_que_20210426.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_rms_20210604.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/Exam-materials/4EC1_02_que_20210504.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_rms_20200305.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_rms_20200305.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_rms_20200305.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_rms_20190822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_rms_20190822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_que_20190604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_rms_20190822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_que_20190604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_rms_20190822.pdf',
        },
      ],
    },
  ],
  accounting: [
    {
      year: '2025',
      papers: [
        {
          label: '1',
          link: 'https://drive.proton.me/urls/0QXQEEJRNC#qTPiktlrWwnj',
          marking: 'https://drive.proton.me/urls/DJ404MBDNR#6zGQARLvewYz',
        },
        {
          label: '1R',
          link: 'https://drive.proton.me/urls/GD7X16JNY8#5NGRx5UFmwig',
          marking: 'https://drive.proton.me/urls/1TRPRW43WW#kdCaPyGpscer',
        },
        {
          label: '2',
          link: 'https://drive.proton.me/urls/74BJYHYKQC#PvMx7naqogvx',
          marking: 'https://drive.proton.me/urls/X634156SAW#V25sUZY7Khti',
        },
        {
          label: '2R',
          link: 'https://drive.proton.me/urls/3GZVWZETJM#ZYQ5RPEialTK',
          marking: 'https://drive.proton.me/urls/6J6FNZYKSM#u7a4zIotSzp6',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01-que-20240516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01-rms-20240822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01r-que-20240516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01r-rms-20240822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02-que-20240613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02-rms-20240822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02r-que-20240613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02r-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01-rms-20230824.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01r-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-01r-rms-20230824.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02-que-20230606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02-rms-20230824.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02r-que-20230606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Accounting/2017/Exam-materials/4ac1-02r-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-01-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-01r-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-02-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-02-rms-20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-02r-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4ac1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/Exam-materials/4AC1_01_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4AC1_01_rms_20210604.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/Exam-materials/4AC1_02_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Accounting/2017/Exam-materials/4AC1_02_rms_20210604.pdf',
        },
      ],
    },
  ],
  ict: [
    {
      year: '2025',
      papers: [
        {
          label: '1',
          link: 'https://drive.proton.me/urls/JK15S3AKD0#GfS9EC44jzqG',
          marking: 'https://drive.proton.me/urls/15H5RC47HG#krx3waO1KBz6',
        },
        {
          label: '1R ',
          link: 'https://drive.proton.me/urls/RZ0GGGX0J8#PQgFiAK7WWfh',
          marking: 'https://drive.proton.me/urls/TRTSANEVN8#BXima76MCC4k',
        },
        {
          label: '2',
          link: 'https://drive.proton.me/urls/G5TCRYAZ68#rHlUrlcK9tWG',
          marking: 'https://drive.proton.me/urls/N8S6DS2HE0#e9CnzODuHjjk',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01-que-20240510.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01-rms-20240822.pdf',
        },
        {
          label: '1R ',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01r-que-20240510.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01r-rms-20240822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-02-que-20240525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-02-rms-20240822.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01-que-20230516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01-rms-20230824.pdf',
        },
        {
          label: '1R ',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01r-que-20230516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-01r-rms-20230824.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-02-que-20230527.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Information-and-Communication-Technology/2017/Exam-materials/4it1-02-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4it1-01-que-20220517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4it1-01-rms-20220825.pdf',
        },
        {
          label: '1R ',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4it1-01r-que-20220517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4it1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4it1-02-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4it1-02-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/Exam-materials/4IT1_01_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4IT1_01_rms_20210604.pdf',
        },
        {
          label: '1R ',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4IT1_02_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Information%20and%20Communication%20Technology/2017/Exam-materials/4IT1_02_rms_20210604.pdf',
        },
      ],
    },
  ],
};

export default papersDataEdexcelIgcse;
